<template>
  <div class="promo-item promo-item--loader">
    <q-skeleton dark type="circle" class="promo-item__img" />

    <div class="promo-item__body">
      <div class="promo-item__description">
        <q-skeleton dark class="promo-item__title" />
        <q-skeleton dark class="promo-item__text" />
      </div>

      <q-skeleton dark class="promo-item__button" />
    </div>

    <q-skeleton dark class="promo-item__badge" />
  </div>
</template>

<style lang="scss">
.promo-item--loader {
  cursor: wait;
  margin-top: 16px;
  gap: 12px;
  background: var(--cas-light-100);

  .promo-item {
    &__img {
      max-width: 140px;
      width: 100%;
      min-height: 140px;
      margin-top: 8px;
      display: flex;
      justify-content: center;
      border-radius: 50%;
      background: var(--cas-light-50);
    }

    &__body {
      min-height: unset;
    }

    &__description {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__title {
      max-width: 220px;
      width: 100%;
      height: 16px;
      border-radius: 4px;
      background: var(--cas-light-50);
      margin-bottom: 8px;
    }

    &__text {
      width: 136px;
      height: 16px;
      border-radius: 4px;
      background: var(--cas-light-50);
    }

    &__button {
      height: 40px;
      border-radius: 4px;
      background: var(--cas-light-50);
    }

    &__badge {
      max-width: 32px;
      width: 100%;
      max-height: 16px;
      height: 100%;
      border-radius: 4px;
      background: var(--cas-light-50);
      box-shadow: none;
    }
  }

  @media (max-width: 1024px) {
    gap: 20px;
    margin-top: 8px;

    .promo-item {
      &__img {
        max-width: 112px;
        min-height: 112px;
      }

      &__title {
        max-width: 136px;
        width: 100%;
        height: 12px;
      }

      &__text {
        width: 80px;
        height: 12px;
      }

      &__button {
        height: 32px;
      }

      &__badge {
        width: 24px;
        height: 12px;
      }
    }
  }

  @media (max-width: 768px) {
    gap: 12px;
    margin-top: 8px;

    .promo-item {
      &__img {
        max-width: 72px;
        min-height: 72px;
      }

      &__badge {
        height: 10px;
      }
    }
  }
}
</style>
